var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Can you spot the 12 hidden birds?")]),_c('v-btn',{staticClass:"start-btn",on:{"click":function($event){return _vm.$emit('start-sound')}}},[_vm._v("Let's go")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }